// extracted by mini-css-extract-plugin
var _1 = "AMMbM";
var _2 = "oUCOM";
export { _1 as "base", _2 as "separator" }
